import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API_ROUTES } from "../../constants/apiRoutes";
import { useAuth } from "../../context/AuthContext";
import bannerImg from "../auth/assets/banner.png";
import logo from "../auth/assets/logo.png";

const Login = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { login } = useAuth();
  const currentYear = new Date().getFullYear();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {

      if(email === "info@dubaicityofgold.ae") {
        alert("Credentials Restricted Please Avoid Using This Credentials")
        return
      }

      
      const response = await axios.post(`${API_ROUTES}Account/login`, {
        email,
        password,
      });
      const token = response.data.token;
      localStorage.setItem("jwtToken", token);

      const userTypeResponse = await axios.get(
        `${API_ROUTES}Account/usertype`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const { roles, username, id } = userTypeResponse.data;
      const userRole = roles[0];
      localStorage.setItem("userRole", userRole);
      localStorage.setItem("user", username);
      localStorage.setItem("id", id);
      login(token, userRole, username, id);

      if (roles.includes("Admin")) {
        navigate("/admin");
      } else {
        navigate("/user");
      }
    } catch (error) {
      console.error("Error logging in", error);
      setError("Invalid email or password");
    }
  };

  return (
    <main className="flex flex-row h-screen w-full bg-white ">
      <section className="w-3/5 text-center p-10">
        <div className="relative">
          <img src={logo} alt="logo" className="w-40" />
        </div>

        <div className="w-3/5 m-auto pt-5  ">
          <h2 className="text-3xl font-semibold p-5">Login</h2>
        </div>

        <div className="w-3/5 m-auto p-10 ">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="form-control">
              <label className="input flex items-center h-12 rounded-2xl outline-none mb-4 border-none bg-gray-100 gap-5">
                <svg
                  width="25"
                  height="25"
                  viewBox="0 0 25 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22.9163 7.84894V17.7083C22.9164 18.5054 22.6118 19.2724 22.065 19.8523C21.5182 20.4323 20.7704 20.7813 19.9747 20.8281L19.7913 20.8333H5.20801C4.41091 20.8334 3.64393 20.5288 3.06399 19.982C2.48404 19.4351 2.13498 18.6874 2.08822 17.8916L2.08301 17.7083V7.84894L11.9215 14.4083L12.0424 14.4771C12.1848 14.5466 12.3412 14.5828 12.4997 14.5828C12.6582 14.5828 12.8146 14.5466 12.957 14.4771L13.0778 14.4083L22.9163 7.84894Z"
                    fill="#808797"
                  />
                  <path
                    d="M19.7917 4.16666C20.9167 4.16666 21.9031 4.76041 22.4531 5.65311L12.5 12.2885L2.54688 5.65311C2.80812 5.22897 3.16697 4.87343 3.59351 4.61612C4.02006 4.35882 4.50193 4.20722 4.99896 4.17395L5.20833 4.16666H19.7917Z"
                    fill="#808797"
                  />
                </svg>

                <input
                  type="text"
                  className="grow text-gray-600 font-semibold"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </label>
            </div>
            <div className="form-control">
              <label className="input flex justify-between items-center h-12 rounded-2xl outline-none border-none bg-gray-100 gap-5">
                <div className="flex flex-row gap-5">
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.5003 17.7084C13.0529 17.7084 13.5828 17.4889 13.9735 17.0982C14.3642 16.7075 14.5837 16.1776 14.5837 15.625C14.5837 15.0725 14.3642 14.5426 13.9735 14.1519C13.5828 13.7612 13.0529 13.5417 12.5003 13.5417C11.9478 13.5417 11.4179 13.7612 11.0272 14.1519C10.6365 14.5426 10.417 15.0725 10.417 15.625C10.417 16.1776 10.6365 16.7075 11.0272 17.0982C11.4179 17.4889 11.9478 17.7084 12.5003 17.7084ZM18.7503 8.33335C19.3029 8.33335 19.8328 8.55285 20.2235 8.94355C20.6142 9.33425 20.8337 9.86415 20.8337 10.4167V20.8334C20.8337 21.3859 20.6142 21.9158 20.2235 22.3065C19.8328 22.6972 19.3029 22.9167 18.7503 22.9167H6.25033C5.69779 22.9167 5.16789 22.6972 4.77719 22.3065C4.38649 21.9158 4.16699 21.3859 4.16699 20.8334V10.4167C4.16699 9.86415 4.38649 9.33425 4.77719 8.94355C5.16789 8.55285 5.69779 8.33335 6.25033 8.33335H7.29199V6.25002C7.29199 4.86868 7.84073 3.54392 8.81748 2.56717C9.79423 1.59042 11.119 1.04169 12.5003 1.04169C13.1843 1.04169 13.8616 1.1764 14.4935 1.43815C15.1254 1.69989 15.6995 2.08353 16.1832 2.56717C16.6668 3.05081 17.0505 3.62497 17.3122 4.25688C17.5739 4.88878 17.7087 5.56605 17.7087 6.25002V8.33335H18.7503ZM12.5003 3.12502C11.6715 3.12502 10.8767 3.45426 10.2906 4.04031C9.70457 4.62636 9.37533 5.42122 9.37533 6.25002V8.33335H15.6253V6.25002C15.6253 5.42122 15.2961 4.62636 14.71 4.04031C14.124 3.45426 13.3291 3.12502 12.5003 3.12502Z"
                      fill="#808797"
                    />
                  </svg>

                  <input
                    className="grow text-gray-600 font-semibold"
                    type={isVisible ? "text" : "password"}
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>
                <button
                  type="button"
                  onClick={() => {
                    setIsVisible(!isVisible);
                  }}
                  className="w-fit text-end border-none outline-none bg-none select-none"
                >
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.3232 9.375L15.6253 12.6667V12.5C15.6253 11.6712 15.2961 10.8763 14.71 10.2903C14.124 9.70424 13.3291 9.375 12.5003 9.375H12.3232ZM7.84408 10.2083L9.45866 11.8229C9.40658 12.0417 9.37533 12.2604 9.37533 12.5C9.37533 13.3288 9.70457 14.1237 10.2906 14.7097C10.8767 15.2958 11.6715 15.625 12.5003 15.625C12.7295 15.625 12.9587 15.5938 13.1774 15.5417L14.792 17.1562C14.0941 17.5 13.3232 17.7083 12.5003 17.7083C11.119 17.7083 9.79423 17.1596 8.81748 16.1828C7.84073 15.2061 7.29199 13.8813 7.29199 12.5C7.29199 11.6771 7.50033 10.9062 7.84408 10.2083ZM2.08366 4.44792L4.45866 6.82292L4.92741 7.29167C3.20866 8.64583 1.85449 10.4167 1.04199 12.5C2.84408 17.0729 7.29199 20.3125 12.5003 20.3125C14.1149 20.3125 15.6566 20 17.0628 19.4375L17.5107 19.875L20.5524 22.9167L21.8753 21.5937L3.40658 3.125M12.5003 7.29167C13.8817 7.29167 15.2064 7.8404 16.1832 8.81715C17.1599 9.7939 17.7087 11.1187 17.7087 12.5C17.7087 13.1667 17.5732 13.8125 17.3337 14.3958L20.3857 17.4479C21.9482 16.1458 23.1982 14.4375 23.9587 12.5C22.1566 7.92708 17.7087 4.6875 12.5003 4.6875C11.042 4.6875 9.64616 4.94792 8.33366 5.41667L10.5941 7.65625C11.1878 7.42708 11.8232 7.29167 12.5003 7.29167Z"
                      fill="#808797"
                    />
                  </svg>
                </button>
              </label>
              <p className="text-end mt-4">
                <a
                  href="/forgot"
                  className="text-gray-400 hover:text-black font-semibold text-sm hover:underline"
                >
                  Forgot your password?
                </a>
              </p>
            </div>
            <button
              type="submit"
              className="btn bg-black text-lg h-12 rounded-2xl text-white font-semibold w-fit px-10"
            >
              Login
            </button>

            {error && (
              <div className="text-red-500 text-center mt-4">{error}</div>
            )}
          </form>
        </div>

        <footer className="p-4 fixed w-3/5 text-center left-0 bottom-0">
          <div className="text-xs text-gray-600">
            <p>
              © Copyright {currentYear} | All Rights Reserved by Dubai Jewellery
              Group.
            </p>
          </div>
        </footer>
      </section>
      <section className="w-2/5 h-auto relative pt-3 pb-3 pl-3 pr-3">
        <img
          src={bannerImg}
          alt="Banner-Img"
          className="w-full h-full  rounded-md"
        />
      </section>
    </main>
  );
};

export default Login;
